import React from 'react';
import _ from 'lodash';

import defaultLogo from 'assets/images/default_logo.svg';
import { getImageStyle } from 'shared/utils/getImageStyle';

import ClaimCompanyForm from './ClaimCompanyForm';

import { formatCompanyDomain } from './utils';

import './styles.scss';

const WhyJoinItem = ({ content }) => {
  return (
    <div className="why-join-item-container">
      <div className="check-icon">
        <i className="material-icons">check</i>
      </div>
      <div className="content">{content}</div>
    </div>
  );
};

class ClaimCompany extends React.Component {
  render() {
    const { company, isInvestor, closeModal } = this.props;

    company.domain = formatCompanyDomain({ company });

    const imageStyles = getImageStyle({
      image: company.logo,
      thumbnails: _.get(company, 'logo_thumbnails', []),
      width: 75,
      height: 75,
      defaultImage: defaultLogo
    });

    return (
      <div className="claim-company-wrapper">
        <div className="claim-company-form-wrapper">
          <div className="content">
            <div className="title">Join {company.name}</div>
            <div className="claim-description">
              Please confirm your {company.name} email address and role below so
              we can send you a verification email.
            </div>
            <ClaimCompanyForm company={company} closeModal={closeModal} />
          </div>
        </div>

        <div className="company-info-wrapper">
          <div className="content">
            <div className="company-data-header remove-xs">
              <div className="company-logo" style={imageStyles} />
              <div className="company-initial-data">
                <div className="company-name">{company.name}</div>
                {!_.isNil(company.industry) && (
                  <div className="company-sector">{company.industry.label}</div>
                )}
              </div>
            </div>
            <div className="why-join-wrapper">
              <div className="title">Why join the team?</div>
              <div className="why-join-items-wrapper">
                <WhyJoinItem content="Be listed as a team member on the company profile page" />
                {!isInvestor && (
                  <React.Fragment>
                    <WhyJoinItem content="Invite and accept other team members" />
                    <WhyJoinItem content="Make edits to the company profile" />
                  </React.Fragment>
                )}
                <WhyJoinItem content="Receive notifications when people follow your company" />
                <WhyJoinItem content="Share news, post jobs and create events associated with your company" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ClaimCompany;
